async function injectThreatMetrixAdvancedProfilingScript(sessionId) {
  const isProd = window.location.host.includes('aeromexico.com') || window.location.host.includes('mex.amlab');
  const profilingDomain = 'https://content.clubpremier.com';
  const prodOrgId = '7d66bbvt';
  const devOrgId = '5nt5jj9y';
  const orgId = isProd ? prodOrgId : devOrgId;
  const pageId = '1';
  const body = document.querySelector('body');
  const script = document.createElement('script');
  const scriptContent = `threatmetrix.profile('${profilingDomain}', '${orgId}', '${sessionId}', '${pageId}');`;
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.style.width = '100px';
  iframe.style.height = '100px';
  iframe.style.border = '0';
  iframe.style.position = 'absolute';
  iframe.style.top = '-5000px';
  iframe.src = `${profilingDomain}/fp/tags?org_id=${orgId}&page_id=${pageId}&session_id=${sessionId}`;
  noscript.appendChild(iframe);
  script.textContent = scriptContent;
  body.append(script);
  body.append(noscript);
}

export { injectThreatMetrixAdvancedProfilingScript };